import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

import {EAisDashboardCode} from './ais-dashboards-constants';
import {TAisDashboardElementDto} from './ais-dashboards-types';

export type TFetchAisDashboardDataParams = {
    code: EAisDashboardCode;
    year?: number;
    month?: number | null;
    day?: number | null;
    periodId?: number;
    counterparty?: string;
    hasAvailableFNS?:boolean;
    startDate?: string;
    endDate?: string;
    taxPeriodId?: number;
    organizationId?: number;
}

export type TFetchAisDashboardDataResponseDto = {
    code: EAisDashboardCode;
    meaning: string;
    total: number;
    elements: TAisDashboardElementDto[];
}

export const fetchAisDashboardData = (params: TFetchAisDashboardDataParams) => performRequest<
TFetchAisDashboardDataResponseDto>({
    url: 'ais/dashboard',
    method: ERequestType.GET,
    params,
});
